<template>
  <div>
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>

export default {
  name: 'GasStationContainer',
  beforeMount() {
    if (this.$route.name === 'GasStationContainer') {
      this.$router.replace({name: 'GasStations' });
    }
  }
}
</script>
